import { ApiBaseFront } from '../api-base-front';

export type StatusList = {
  kijshopCd: string,
  shopOrderId: string,
  lastUpdateDate: string,
  createDate: string,
  lastName: string | null,
  status: string,
  orderDate: string | null,
  note: string | null,
  lockUser: string | null,
  deleteDate: string | null,
  isOneStop?: 0 | 1,
  isOlc?: 0 | 1,
  isOneStopCancel?: 0 | 1,
  cfOrderId?: string,
  oneStopOrderUser: string | null,
  oneStopOrderDate: string | null,
  orderUser: string,
  laboOrder?: {
    isSuccess: 0 | 1,
    orderCompleteDate: string,
  }
  isOlcDelivery?: 0 | 1,
  centerShippinDate?: string,
  // コピーして新規で作成された注文のコピー元注文番号(通常注文は未設定)
  copySrcShopOrderId?: string | null,
}[];

export type ShopOrderStatusListGetResponse = {
  statusList: StatusList,
};

// export type ShopOrderListGetResponseStatus = {
//   shopOrderIdList: ShopOrderListGetResponse[],
//   // statusList: ShopOrderListGetResponse[],
// };
//
export class ApiShopOrderStatusListGet extends ApiBaseFront<ShopOrderStatusListGetResponse> {
  constructor(kijShopCd: string) {
    super(
      'GET',
      `/api/v1/orderxml/${kijShopCd}/status`,
      'JSON',
      {},
    );
  }
}

export type ShopOrderListGetResponseStatus = ShopOrderStatusListGetResponse;

export class ApiShopOrderListGet extends ApiBaseFront<ShopOrderListGetResponseStatus> {
  constructor(kijshopCd: string) {
    super(
      'GET',
      `/api/v1/orderxml/${kijshopCd}/status`,
      'JSON',
      // { is_first: '1' },
      {},
    );
  }
}

export type ShopOrderListSortGetRequest = {
  kijshopCd: string,
  date_kind?: string,
  date_start?: string,
  date_end?: string,
  lastName?: string,
  shopOrderId?: string,
  status?: string,
  sort_by?: string,
  highlow?: string,
  is_first?: string,
};

export class ApiShopOrderListSortGet extends ApiBaseFront<ShopOrderListGetResponseStatus> {
  constructor(_param: ShopOrderListSortGetRequest) {
    const { kijshopCd } = _param;
    super(
      'GET',
      `/api/v1/orderxml/${kijshopCd}/status`,
      'JSON',
      {},
    );
  }
}
